import React from 'react';
import { Button } from '@everlywell/leaves'
import * as S from './styles';

type Props = {
    textAccent: string;
    title: string;
    description: string;
    buttonText: string;
    upgradeCost: string;
    handleOnClick: Function;
    backgroundImageUrl: string;
};

const CartUpsell = ({
    textAccent, 
    title, 
    description, 
    buttonText, 
    upgradeCost, 
    handleOnClick, 
    backgroundImageUrl,
}: Props) => {
    return (
        <div data-testid='fs-to-fsc-upsell-card'>
            <S.TextAccent>{textAccent}</S.TextAccent>
            <S.UpsellContainer>
                <S.CardImage backgroundImageUrl={backgroundImageUrl} />
                <S.CardTitle>
                    {title}
                </S.CardTitle>
                <S.CardDescription>
                    {description}
                </S.CardDescription>
                <S.ButtonCostContainer>
                    <Button data-testid='fs-to-fsc-upsell-card-button' appearance="tertiary" onClick={() => handleOnClick()}>
                        {buttonText}
                    </Button>
                    <S.UpgradeCost>
                        {upgradeCost}
                    </S.UpgradeCost>
                </S.ButtonCostContainer>
            </S.UpsellContainer>
        </div>
    );
};

export default CartUpsell;
